export const organizationHeaderStyle = {
	header: {
		backgroundColor: 'var(--default-white)',
		position: 'sticky',
		top: 0,
		zIndex: 100,
		// boxShadow: 'var(--box-shadow--1)',
		flexShrink: 0,
	},

	panel: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		margin: '0 auto',
		maxWidth: '1200px',
		width: '100%',
		maxHeight: '80px',
		padding: '15px',

		'@media (max-width: 1199.98px)': {
			maxWidth: '100vw',
			maxHeight: 'none',
			padding: '15px 40px',
		},

		'@media (max-width: 639.98px)': {
			padding: '15px 20px',
		},
	},

	logo: {
		minWidth: '275px',
		marginRight: '24px',

		'@media (max-width: 1199.98px)': {
			display: 'none',
		},
	},

	panelInfo: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		minWidth: 0,
		gap: '20px',

		'@media (max-width: 767.98px)': {
			flexDirection: 'column-reverse',
			justifyContent: 'center',
		},
	},

	panelCenter: {
		display: 'flex',
		alignItems: 'center',
		minWidth: 0,
		flex: '1 1 auto',
		gap: '24px',

		'@media (max-width: 767.98px)': {
			width: '100%',
		},

		'@media (max-width: 639.98px)': {
			flexDirection: 'column-reverse',
			gap: '16px',
		},
	},

	progressWrap: {
		minWidth: '180px',
		maxWidth: '300px',
		flexShrink: 1,

		'@media (max-width: 767.98px)': {
			minWidth: '50%',
		},

		'@media (max-width: 639.98px)': {
			minWidth: '100%',
		},
	},

	progressValue: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '8px',
		alignItems: 'center',
	},

	progressTargetAmount: {
		fontWeight: '700',
		fontSize: '14px',
		whiteSpace: 'nowrap',
	},

	progressTargetGoal: {
		color: 'var(--neutral-300)',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},

	user: {
		display: 'flex',
		alignItems: 'center',
		gap: '24px',

		'& > div': {
			width: '100%',
		},

		'@media (max-width: 767.98px)': {
			width: '100%',
			flexDirection: 'row-reverse',
			justifyContent: 'space-between',
		},
	},

	loginButton: {
		maxWidth: '175px',
	},

	notificationButton: {
		width: '44px',
		height: '44px',
		background: 'var(--background-grey-op-50-1)',
	},
};
